/* eslint-disable no-param-reassign */
import uniqBy from 'lodash/uniqBy';
import themeService from '@/services/themeService';
import { mapGetters } from 'vuex';

export default {
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    itemsUniqueProperty: {
      type: String,
      default: 'name',
    },
  },
  data: () => ({
    chartsRefs: [],
    hiddenLegends: [],
  }),
  computed: {
    ...mapGetters(['isPrinting']),
    legend() {
      const result = uniqBy(this.chartData, this.itemsUniqueProperty);
      return result;
    },
    fontColor() {
      return this.isPrinting
        ? themeService.getStyleVar('color-gray-medium-dark')
        : themeService.getFontColor();
    },
  },
  methods: {
    changeLegend(data) {
      const batchSelection = data.batch && data.batch[data.batch.length - 1];
      const selected = data.selected || batchSelection?.selected || {};
      const legends = Object.entries(selected);
      const hiddenLegends = legends.filter(legend => !legend[1]);
      this.hiddenLegends = hiddenLegends.map(item => item[0]);
    },
    toggleLegend(values) {
      (this.chartsRefs || []).forEach(ref => {
        if (!values.length) return;

        this.$refs[ref].dispatchAction({
          type: 'legendToggleSelect',
          batch: values.map(item => ({ name: item.name })),
        });
      });
    },
    selectAllLegends() {
      (this.chartsRefs || []).forEach(ref => {
        this.$refs[ref].dispatchAction({
          type: 'legendAllSelect',
        });
      });
      this.hiddenLegends = [];
    },
    unselectAllLegends() {
      (this.chartsRefs || []).forEach(ref => {
        const batch = this.legend.map(item => ({
          name: item.name || item[this.itemsUniqueProperty],
        }));

        if (!batch.length) return;

        this.$refs[ref].dispatchAction({
          type: 'legendUnSelect',
          batch,
        });
      });
      this.hiddenLegends = this.legend.map(
        item => item[this.itemsUniqueProperty],
      );
    },
  },
};
